import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const AccessControlsPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./AccessControls/AccessControlsPage'))
      .AccessControlsPage,
  }))
);

export const NotificationTemplateModal = withLazyComponent(
  lazy(async () => ({
    default: (
      await import(
        './Notifications/components/NotificationTemplateModal/NotificationTemplateModal'
      )
    ).NotificationTemplateModal,
  }))
);

export const NotificationsListPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Notifications/NotificationsListPage'))
      .NotificationsListPage,
  }))
);

export const NotificationsPipelinePage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Notifications/NotificationsPipelinePage'))
      .NotificationsPipelinePage,
  }))
);

export const NotificationsRosterPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Notifications/NotificationsRosterPage'))
      .NotificationsRosterPage,
  }))
);

export const OrganizationAdminPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./OrganizationAdminPage')).OrganizationAdminPage,
  }))
);

export const OrganizationComplianceGroupStageMapping = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Admins/OrganizationComplianceGroupStageMapping'))
      .OrganizationComplianceGroupStageMapping,
  }))
);

export const OrganizationDarwinCompanyMapping = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Admins/OrganizationDarwinCompanyMapping'))
      .OrganizationDarwinCompanyMapping,
  }))
);

export const OrganizationCompliancePage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Compliance/OrganizationCompliancePage'))
      .OrganizationCompliancePage,
  }))
);

export const OrganizationIntegrationConnections = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Admins/OrganizationIntegrationConnections'))
      .OrganizationIntegrationConnections,
  }))
);

export const OrganizationNotificationsPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Notifications/OrganizationNotificationsPage'))
      .OrganizationNotificationsPage,
  }))
);

export const OrganizationOfferBenchmarksPage = withLazyComponent(
  lazy(async () => ({
    default: (
      await import(
        './OrganizationOfferBenchmarks/OrganizationOfferBenchmarksPage'
      )
    ).OrganizationOfferBenchmarksPage,
  }))
);

export const OrganizationOfferScorecardsPage = withLazyComponent(
  lazy(async () => ({
    default: (
      await import(
        './OrganizationOfferScorecards/OrganizationOfferScorecardsPage'
      )
    ).OrganizationOfferScorecardsPage,
  }))
);

export const OrganizationPageLayout = withLazyComponent(
  lazy(async () => ({
    default: (await import('./OrganizationPageLayout')).OrganizationPageLayout,
  }))
);

export const OrganizationMortgagePerformanceDemoPage = withLazyComponent(
  lazy(async () => ({
    default: (
      await import('./DemoPerformance/OrganizationMortgagePerformanceDemoPage')
    ).OrganizationMortgagePerformanceDemoPage,
  }))
);

export const OrganizationEssentialsPerformanceDemoPage = withLazyComponent(
  lazy(async () => ({
    default: (
      await import('./DemoPerformance/OrganizationEssentialsPerformanceDemoPage')
    ).OrganizationEssentialsPerformanceDemoPage,
  }))
);

export const OrganizationFlexPerformanceDemoPage = withLazyComponent(
  lazy(async () => ({
    default: (
      await import('./DemoPerformance/OrganizationFlexPerformanceDemoPage')
    ).OrganizationFlexPerformanceDemoPage,
  }))
);

export const OrganizationComplianceDashboardDemoPage = withLazyComponent(
  lazy(async () => ({
    default: (
      await import(
        './ComplianceDashboardDemo/OrganizationComplianceDashboardDemoPage'
      )
    ).OrganizationComplianceDashboardDemoPage,
  }))
);

export const OrganizationPerformancePage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Performance/OrganizationPerformancePage'))
      .OrganizationPerformancePage,
  }))
);

export const OrganizationPipelinePage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Pipeline/OrganizationPipelinePage'))
      .OrganizationPipelinePage,
  }))
);

export const OrganizationDemoPipelinePage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./DemoPipeline/OrganizationDemoPipelinePage'))
      .OrganizationDemoPipelinePage,
  }))
);

export const DemoSalesPipelineComplianceDrawer = withLazyComponent(
  lazy(async () => ({
    default: (
      await import(
        '../../components/DemoSalesPipeline/DemoSalesPipelineComplianceDrawer'
      )
    ).DemoSalesPipelineComplianceDrawer,
  }))
);

export const PartnerNotificationsPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./Notifications/PartnerNotificationsPage'))
      .PartnerNotificationsPage,
  }))
);

export const DataCoachChatPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./DataCoachChat/DataCoachChatPage'))
      .DataCoachChatPage,
  }))
);
